// Re-export User from core APIs to maintain a single source of truth
export type { User } from '@/apis/core';

export type Profile = {
  city: string;
  companyName: string;
  country: string;
  createDate: string;
  displayName: string;
  dpaSigned: boolean;
  ein: string;
  emails: string[];
  entityType: string;
  escalateEmails: string[];
  financeEmails: string[];
  maxBrands: number;
  maxCampaignsPerBrand: number;
  maxPortalUsers: number;
  mfaEnabled: boolean;
  platformFreeTrialEnabled: boolean;
  postalCode: string;
  soleProprietorEnabled: boolean;
  state: string;
  stockExchange: string;
  stockSymbol: string;
  street: string;
  techEmails: string[];
  ucaasEnabled: boolean;
  uid: string;
  website: string;
  migrationSupported: boolean;
  migrationAutoComplete: boolean;
};

export type EmailPreference = {
  email: string;
};

export type EmailPreferencesUpdatePayload = {
  emails: EmailPreference[];
  escalateEmails: EmailPreference[];
  financeEmails: EmailPreference[];
  techEmails: EmailPreference[];
};

export type UserCreatePayload = {
  email: string;
  firstName: string;
  lastName: string;
  userAppRole: string;
  secondaryUserAppRoles: string[];
};

export type UserUpdatePayload = {
  userAppRole: string;
  secondaryUserAppRoles: string[];
};

export const Modal = {
  ADD: 'add',
  EDIT: 'edit',
  DELETE: 'delete',
} as const;

export type ModalType = (typeof Modal)[keyof typeof Modal];
